import { ErrorBoundary } from 'react-error-boundary';

import { useAppSelector } from '@/Application/Hooks/Redux';
import { selectIsProcessingPayment } from '@/Application/Selectors/buyNow/useBuyNowCart';
import { PaymentLoader } from '@/modules/perseo-billing/components';
import { notifyError } from '@/modules/perseo-billing/services/error-handler';
import FallbackBuyNow from '@/Pages/BuyNowPage/BuyNowFallback';
import { BuyNowPageContent } from '@/Pages/BuyNowPage/BuyNowPageContent';

const BuyNowPage = () => {
  const isProcessingPayment = useAppSelector(selectIsProcessingPayment);

  if (isProcessingPayment) return <PaymentLoader />;

  return (
    <ErrorBoundary FallbackComponent={FallbackBuyNow} onError={notifyError}>
      <BuyNowPageContent />
    </ErrorBoundary>
  );
};

BuyNowPage.displayName = 'BuyNowPage';

export default BuyNowPage;
